<template>
  <b-navbar centered>
    <template slot="start">
      <b-navbar-item tag="div">
        <div class="">
          <router-link to="/" class=" is-primary">
            <strong>Feed</strong>
          </router-link>
        </div>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="">
          <router-link to="/creators" class=" is-primary">
            <strong>Creators</strong>
          </router-link>
        </div>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="">
          <router-link to="/about" class=" is-primary">
            <strong>About</strong>
          </router-link>
        </div>
      </b-navbar-item>
      <b-navbar-item id="logo" tag="router-link" :to="{ path: '/' }">
        <figure id="GILOGO" class="swing">
          <img
            src="@/assets/GIUpdates-Logo@0.75x.png"
            alt="Gaming Illuminaughty Updates Logo"
          />
        </figure>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="">
          <a
            href="https://streamlabs.com/giupdates/merch"
            class=" is-primary"
            target="_blank"
          >
            <strong>Merch</strong>
          </a>
        </div>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="">
          <router-link to="/sponsors" class=" is-primary">
            <strong>Sponsors</strong>
          </router-link>
        </div>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="">
          <router-link to="/contact" class=" is-primary">
            <strong>Contact</strong>
          </router-link>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
nav {
  border-top: 2px solid #bf9c5a;
  text-align: center;
  background-color: #0d0c10 !important;
}
.navbar-item {
  color: ghostwhite;
  align-items: center;
  justify-content: center;
  width: 150px;
  a {
    color: ghostwhite;
    text-align: center;
    transition: all 200ms ease-in-out;
  }
  &:hover {
    a {
      color: #bf9c5a;
    }
  }
}
#logo {
  &:hover {
    background: transparent !important;
  }
}
#GILOGO {
  position: absolute;
  top: 15px;
  left: 0;
  max-height: 350px !important;
}

.swing {
  animation: swing ease-in-out 4s infinite alternate;
  transform-origin: center -20px;
  float: left;
}
.swing img {
  display: block;
  max-height: 350px !important;
}

@keyframes swing {
  0% {
    transform: rotate(2deg);
  }
  100% {
    transform: rotate(-2deg);
  }
}
</style>
